'use client';

import { useWindowSize } from 'codekit';

import { Icon } from 'components/Icon';
import RenderOn from 'components/RenderOn';
import { app } from 'config/app';
import { social } from 'constants/institutional';
import Button from 'layouts/institucional/Button';
import Section from '..';
import AnimationDotsMesh from './AnimationDotsMesh';

import styles from './styles.module.css';

function SectionCTA() {
	// Hooks
	const size = useWindowSize();

	return (
		<Section
			id="cta"
			containerClassName={styles.container}
			className={styles.content}
			height="80vh"
			containerChildren={
				size.isDesktop ? (
					<RenderOn.Idle>
						<RenderOn.InView topOffset={2000}>
							<AnimationDotsMesh />
						</RenderOn.InView>
					</RenderOn.Idle>
				) : null
			}
		>
			<div className={styles.text}>
				<h1>
					Mas código. <br />
					Menos mensagens.
				</h1>

				<p>
					Gaste menos tempo escrevendo mensagens de commit e mais
					tempo escrevendo código. O {app.name} é a ferramenta para
					você que quer focar no que realmente importa sem perder a
					padronização dos projetos.
				</p>

				<div className={styles.buttons}>
					<Button
						linkTo="auth.register"
						variant="default"
						linkProps={{
							'aria-label': 'Criar conta e testar grátis',
						}}
					>
						Criar conta e testar grátis
						<Icon name="MoveRight" className="move-right" />
					</Button>

					<a
						href={social.whatsapp}
						target="_blank"
						rel="noreferrer noopener"
						aria-label="Fale conosco pelo WhatsApp"
					>
						<Button variant="text">
							Fale conosco <Icon name="Whatsapp" />
						</Button>
					</a>
				</div>
			</div>
		</Section>
	);
}

export default SectionCTA;
